export default "__VITE_ASSET__qmU0hwLb__"